import React from "react";
import PurchaseWindowSuccess from "./PurchaseWindowSuccess";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";

const PurchaseWindowPaymentSuccess = ({ close }) => {
  return (
    <div className="modal-window__wrapper" onClick={(e) => e.stopPropagation()}>
      <PagePopopCloseButton close={close} />
      <PurchaseWindowSuccess close={close} />
    </div>
  );
};

export default PurchaseWindowPaymentSuccess;
